import React from 'react';

import Typography from '../../../../../../library/typography/typography';
import ProductArticleStatusBanner from '../../../../../../components/product-article-status-banner/product-article-status-banner.one-dt';
import ProductAvailability from '../../../../../../components/product-availability/product-availability';

import {
  getPrioritizedArticleStatusProduct,
  getShouldShowProductArticleStatusBanner
} from '../../../../../../shared/utils/product/product';

import { BundleData } from '../../../../../../shared/types/product';

import './product-list-package-card-header.one-dt.scss';

interface ProductListPackageCardHeaderProps {
  prebuiltPackage?: BundleData;
  quantity?: number;
}

function ProductListPackageCardHeader(
  props: ProductListPackageCardHeaderProps
) {
  const { prebuiltPackage, quantity } = props;

  const articleStatusProduct = getPrioritizedArticleStatusProduct(
    prebuiltPackage?.product1,
    prebuiltPackage?.product2
  );
  const shouldShowProductArticleStatusBanner =
    getShouldShowProductArticleStatusBanner(articleStatusProduct);

  return (
    <header styleName="container">
      <Typography styleName="package-includes" tag="div">
        <Typography styleName="first-line" tag="span">
          Tire & Wheel Package
        </Typography>
        Package includes: 4 tires and 4 wheels
      </Typography>

      {!shouldShowProductArticleStatusBanner && (
        <ProductAvailability
          prebuiltPackage={prebuiltPackage}
          product={articleStatusProduct}
          quantity={quantity}
        />
      )}
      {shouldShowProductArticleStatusBanner && (
        <ProductArticleStatusBanner product={articleStatusProduct} />
      )}
    </header>
  );
}

export default ProductListPackageCardHeader;
